import { createGlobalStyle } from "styled-components";

import { FONT_CDN } from "@/config";

import { FontFace } from "./helper";
import ResetCSS from "./ResetCSS";

export type IFontFamily = {
  default: string;
  bild: string;
  welt: string;
  aubi: string;
  cobi: string;
  spobi: string;
  bild_fitbook: string;
  bild_stylebook: string;
  bild_techbook: string;
  bild_travelbook: string;
  bild_myhomebook: string;
  bild_brandstory: string;
  bild_productstory: string;
  welt_brandstory: string;
  welt_productstory: string;
  icon: string;
  manschaftsbus: string;
  mediapioneer: string;
  musikexpress: string;
  metalhammer: string;
};

const fontFaceConfig: IFontFamily = {
  default: `
        ${FontFace("Ubuntu", `${FONT_CDN}/Ubuntu/ubuntu-regular-webfont`)}
        ${FontFace(
          "Ubuntu Condensed",
          `${FONT_CDN}/Ubuntu/ubuntu-condensed-webfont`,
          400
        )}
        ${FontFace("Ubuntu", `${FONT_CDN}/Ubuntu/ubuntu-bold-webfont`, 600)}
    `,
  cobi: `
        ${FontFace("Open Sans", `${FONT_CDN}/OpenSans/OpenSans-Regular`)}
        ${FontFace("Open Sans", `${FONT_CDN}/OpenSans/OpenSans-Light`, 200)}
        ${FontFace("Open Sans", `${FONT_CDN}/OpenSans/OpenSans-Bold`, 600)}
        ${FontFace(
          "Open Sans",
          `${FONT_CDN}/OpenSans/OpenSans-ExtraBold`,
          900
        )}`,
  aubi: `
        ${FontFace("Open Sans", `${FONT_CDN}/OpenSans/OpenSans-Regular`)}
        ${FontFace("Open Sans", `${FONT_CDN}/OpenSans/OpenSans-Light`, 200)}
        ${FontFace("Open Sans", `${FONT_CDN}/OpenSans/OpenSans-Bold`, 600)}
        ${FontFace(
          "Open Sans",
          `${FONT_CDN}/OpenSans/OpenSans-ExtraBold`,
          900
        )}`,
  bild: `
        ${FontFace("Gotham", `${FONT_CDN}/Gotham/Gotham-Normal`, 200)}
        ${FontFace("Gotham", `${FONT_CDN}/Gotham/Gotham-Medium`, 600)}
        ${FontFace("Gotham", `${FONT_CDN}/Gotham/Gotham-Bold`, 800)}
        ${FontFace(
          "GothamCondensed",
          `${FONT_CDN}/Gotham/GothamCondensed-Normal`,
          600
        )}
        ${FontFace(
          "GothamCondensed",
          `${FONT_CDN}/Gotham/GothamCondensed-Bold`,
          700
        )}
        ${FontFace(
          "GothamXNarrow",
          `${FONT_CDN}/Gotham/GothamXNarrow-Normal`,
          400
        )}
        ${FontFace(
          "GothamXNarrow",
          `${FONT_CDN}/Gotham/GothamXNarrow-Bold`,
          700
        )}
    `,
  bild_fitbook: `
        ${FontFace("Open Sans", `${FONT_CDN}/OpenSans/OpenSans-Regular`)}
        ${FontFace("Open Sans", `${FONT_CDN}/OpenSans/OpenSans-Light`, 200)}
        ${FontFace("Open Sans", `${FONT_CDN}/OpenSans/OpenSans-Bold`, 600)}
        ${FontFace("Open Sans", `${FONT_CDN}/OpenSans/OpenSans-ExtraBold`, 900)}
    `,
  bild_stylebook: `
        ${FontFace("Open Sans", `${FONT_CDN}/OpenSans/OpenSans-Regular`)}
        ${FontFace("Open Sans", `${FONT_CDN}/OpenSans/OpenSans-Light`, 200)}
        ${FontFace("Open Sans", `${FONT_CDN}/OpenSans/OpenSans-Bold`, 600)}
        ${FontFace("Open Sans", `${FONT_CDN}/OpenSans/OpenSans-ExtraBold`, 900)}
    `,
  bild_techbook: `
        ${FontFace("Open Sans", `${FONT_CDN}/OpenSans/OpenSans-Regular`)}
        ${FontFace("Open Sans", `${FONT_CDN}/OpenSans/OpenSans-Light`, 200)}
        ${FontFace("Open Sans", `${FONT_CDN}/OpenSans/OpenSans-Bold`, 600)}
        ${FontFace("Open Sans", `${FONT_CDN}/OpenSans/OpenSans-ExtraBold`, 900)}
    `,
  bild_travelbook: `
        ${FontFace("Open Sans", `${FONT_CDN}/OpenSans/OpenSans-Regular`)}
        ${FontFace("Open Sans", `${FONT_CDN}/OpenSans/OpenSans-Light`, 200)}
        ${FontFace("Open Sans", `${FONT_CDN}/OpenSans/OpenSans-Bold`, 600)}
        ${FontFace("Open Sans", `${FONT_CDN}/OpenSans/OpenSans-ExtraBold`, 900)}
    `,
  bild_myhomebook: `
        ${FontFace("Open Sans", `${FONT_CDN}/OpenSans/OpenSans-Regular`)}
        ${FontFace("Open Sans", `${FONT_CDN}/OpenSans/OpenSans-Light`, 200)}
        ${FontFace("Open Sans", `${FONT_CDN}/OpenSans/OpenSans-Bold`, 600)}
        ${FontFace("Open Sans", `${FONT_CDN}/OpenSans/OpenSans-ExtraBold`, 900)}
    `,
  bild_brandstory: `
        ${FontFace("Gotham", `${FONT_CDN}/Gotham/Gotham-Normal`, 200)}
        ${FontFace("Gotham", `${FONT_CDN}/Gotham/Gotham-Bold`, 800)}
        ${FontFace(
          "GothamCondensed",
          `${FONT_CDN}/Gotham/GothamCondensed-Normal`,
          600
        )}
        ${FontFace(
          "GothamCondensed",
          `${FONT_CDN}/Gotham/GothamCondensed-Bold`,
          700
        )}
        ${FontFace(
          "GothamXNarrow",
          `${FONT_CDN}/Gotham/GothamXNarrow-Normal`,
          400
        )}
        ${FontFace(
          "GothamXNarrow",
          `${FONT_CDN}/Gotham/GothamXNarrow-Bold`,
          700
        )}
    `,
  bild_productstory: `
        ${FontFace(
          "LucidaGrande",
          `${FONT_CDN}/LucidaGrande/LucidaGrande`,
          200
        )}
        ${FontFace(
          "LucidaGrande",
          `${FONT_CDN}/LucidaGrande/LucidaGrandeBold`,
          600
        )}
    `,
  welt: `
        ${FontFace("ffmark", `${FONT_CDN}/FFMark/Mark-Regular`, 200)}
        ${FontFace(
          "ffmark Condensed",
          `${FONT_CDN}/FFMark/Mark-Extralight`,
          400
        )}
        ${FontFace("ffmark", `${FONT_CDN}/FFMark/Mark-Heavy`, 800)}
        ${FontFace("freight", `${FONT_CDN}/FFMark/FreightText-Book`, 400)}
        ${FontFace(
          "freight",
          `${FONT_CDN}/FFMark/FreightText-BoldItalic`,
          600,
          "italic"
        )}
    `,
  welt_brandstory: `
        ${FontFace("ffmark", `${FONT_CDN}/FFMark/Mark-Regular`, 200)}
        ${FontFace(
          "ffmark Condensed",
          `${FONT_CDN}/FFMark/Mark-Extralight`,
          400
        )}
        ${FontFace("ffmark", `${FONT_CDN}/FFMark/Mark-Heavy`, 800)}
        ${FontFace("freight", `${FONT_CDN}/FFMark/FreightText-Book`, 400)}
        ${FontFace(
          "freight",
          `${FONT_CDN}/FFMark/FreightText-BoldItalic`,
          600,
          "italic"
        )}
    `,
  welt_productstory: `
        ${FontFace("ffmark", `${FONT_CDN}/FFMark/Mark-Regular`, 200)}
        ${FontFace(
          "ffmark Condensed",
          `${FONT_CDN}/FFMark/Mark-Extralight`,
          400
        )}
        ${FontFace("ffmark", `${FONT_CDN}/FFMark/Mark-Heavy`, 800)}
        ${FontFace("freight", `${FONT_CDN}/FFMark/FreightText-Book`, 400)}
        ${FontFace(
          "freight",
          `${FONT_CDN}/FFMark/FreightText-BoldItalic`,
          600,
          "italic"
        )}
    `,
  icon: `
        ${FontFace("ffmark", `${FONT_CDN}/FFMark/Mark-Regular`, 200)}
        ${FontFace(
          "ffmark Condensed",
          `${FONT_CDN}/FFMark/Mark-Extralight`,
          400
        )}
        ${FontFace("ffmark", `${FONT_CDN}/FFMark/Mark-Heavy`, 800)}
        ${FontFace("freight", `${FONT_CDN}/FFMark/FreightText-Book`, 400)}
        ${FontFace(
          "freight",
          `${FONT_CDN}/FFMark/FreightText-BoldItalic`,
          600,
          "italic"
        )}
    `,
  manschaftsbus: `
        ${FontFace("ffmark", `${FONT_CDN}/FFMark/Mark-Regular`, 200)}
        ${FontFace(
          "ffmark Condensed",
          `${FONT_CDN}/FFMark/Mark-Extralight`,
          400
        )}
        ${FontFace("ffmark", `${FONT_CDN}/FFMark/Mark-Heavy`, 800)}
        ${FontFace("freight", `${FONT_CDN}/FFMark/FreightText-Book`, 400)}
        ${FontFace(
          "freight",
          `${FONT_CDN}/FFMark/FreightText-BoldItalic`,
          600,
          "italic"
        )}
    `,
  mediapioneer: `
        ${FontFace(
          "Poppins",
          `${FONT_CDN}/Poppins/poppins-v15-latin-regular`,
          400
        )}
        ${FontFace("Poppins", `${FONT_CDN}/Poppins/poppins-v15-latin-700`, 700)}
      `,
  musikexpress: `
      ${FontFace(
        "Poppins",
        `${FONT_CDN}/Poppins/poppins-v15-latin-regular`,
        400
      )}
      ${FontFace("Poppins", `${FONT_CDN}/Poppins/poppins-v15-latin-700`, 700)}
    `,
  metalhammer: `
      ${FontFace("Arvo", `${FONT_CDN}/Arvo/arvo-latin-400`, 400)}
      ${FontFace("Arvo", `${FONT_CDN}/Arvo/arvo-latin-700`, 700)}
    `,
  spobi: `
        ${FontFace("AntennaCondBold", `${FONT_CDN}/Antenna/AntennaCondBold`)}
    `,
};

export type GlobalStyleProps = {
  fonts: keyof IFontFamily;
  theme: ITheme;
};

// postcss-styled-components-disable-next-line
export default createGlobalStyle`
    /* Global font-face imports */
    ${(props: GlobalStyleProps) =>
      fontFaceConfig[props.fonts] || fontFaceConfig.default};

    /* Global CSS resets and styling */
    ${ResetCSS}

    *, *:before, *:after {
        box-sizing: border-box;
    }

    html, body {
        font-family: ${(props: GlobalStyleProps) =>
          props.theme.globals.fontFamily};
        font-size: ${(props: GlobalStyleProps) => props.theme.typography.h400};
        line-height: 1.4;
        color: ${(props: GlobalStyleProps) => props.theme.colors.black};
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        overflow-x: hidden;
        text-rendering: optimizeLegibility;
        min-width: 250px;
    }

    textarea {
      line-height: 1.4;
    }


    a {
        color: ${(props: GlobalStyleProps) => props.theme.colors.linkText};
        text-decoration: none;
    }

    b, strong, h1, h2, h3, h4, h5 {
        font-family: ${(props: GlobalStyleProps) =>
          props.theme.globals.fontFamily600};
        font-weight: 600;
    }
`;
